// // Use $ instead of jQuery without replacing global $
(function($) {

  $(window).on("load", function() {
    if ($('.hero-slider').length > 0) {
      if ($(".hero-slider .item").length > 1) {
      var hero_image = $('.hero-slider .bg-img img');
      objectFitImages(hero_image);

      // $('.hero-slider .slider-wrap').css({"opacity": 1});
      var value = $('.hero-slider').attr('data-slide').toLowerCase();

      if (value == 'true') {
        $('.hero-slider .slider-wrap .slider').slick({
          arrows: true,
          slidesToShow: 1,
          speed: 800,
          fade: true,
          infinite: true,
          draggable: true,
          autoplay: true,
          dots: true,
          prevArrow: $('.hero-slider .slide-nav .slide-prev'),
          nextArrow: $('.hero-slider .slide-nav .slide-next'),
          dotsClass: 'dots-container',
          appendDots: $('.dots-wrapper'),
          customPaging: function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<span class="dots"></span>';
          }
        });
      } else {
        $('.hero-slider .slider-wrap .slider').slick({
          arrows: true,
          slidesToShow: 1,
          speed: 800,
          fade: true,
          infinite: true,
          draggable: true,
          dots: true,
          prevArrow: $('.hero-slider .slide-nav .slide-prev'),
          nextArrow: $('.hero-slider .slide-nav .slide-next'),
          dotsClass: 'dots-container',
          appendDots: $('.dots-wrapper'),
          customPaging: function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<span class="dots"></span>';
          }
        });
      }
    }
  }
    // Play video on banner.

    if ($('.hero-slider .video').length > 0) {
      $('.hero-slider .bg-img.video video').prop('muted', true)[0].play();
    }
  });

  $('.hero-slider .slider-wrap').on('afterChange', function(event, slick, currentSlide, nextSlide) {

    if ($(".slick-current").hasClass("content-right")) {
      $(".hero-slider .controls").addClass("arrow-left");
    } else {
      $(".hero-slider .controls").removeClass("arrow-left");
    }
  });

  if ($(".slick-current .content").hasClass("content-right")) {
    $(".hero-slider .controls").addClass("arrow-left");
  }


  $('.hero-slider .slider-wrap .slider').on('init', function(event, slick) {
    $('.hero-slider .slider-wrap .slider .item').addClass('active');
  });

  $('.hero-slider .item').each(function() {
    $('.bg-img.mobile').parent('.item').find('.bg-img').addClass('desktop');
  });


})(jQuery);
